import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { cloneDeep, sortBy } from 'lodash';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataQueryService } from '../../classroom360/data-query/data-query.service';
import { DataQueryInformation } from '../../classroom360/data-query/models/data-query-information';
import { DataQueryResult } from '../../classroom360/data-query/models/data-query-result.model';
import { DataQuery } from '../../classroom360/data-query/models/data-query.model';
import { PermissionGroupDescription } from '../../management360/staff/permissions-groups/permissions-groups.model';
import { PermissionsGroupsService } from '../../management360/staff/permissions-groups/permissions-groups.service';
import { StaffService } from '../../management360/staff/staff.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { TylerMatTableDataSource } from '../angular-material/extended.class';
import { School } from '../year/school.model';
import { YearService } from '../year/year.service';
import { AdvancedStaffSearchComponent } from './advanced-staff-search/advanced-staff-search.component';
import { StaffListDialogComponent } from './staff-list-dialog/staff-list-dialog.component';
import { StaffSearchService } from './staff-search.service';
import { Staff, StaffSearchCriteria } from './staff.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-staff-search',
    templateUrl: './staff-search.component.html',
    styleUrls: ['./staff-search.component.css']
})
export class StaffSearchComponent implements OnInit, OnDestroy, AfterViewInit {

    // Data Query Properties
    private _currentQuery = new DataQuery();
    private _information = new DataQueryInformation();

    // Properties
    searchAndSelect = true;
    staff: Staff[] = [];
    dataSource: TylerMatTableDataSource = new TylerMatTableDataSource(this.staff);
    defaultColumns: string[] = [];
    columnsToDisplay: string[] = [];
    subscriptions: Subscription[] = [];
    allSelected: boolean;
    employeeNumber = '';
    firstName = '';
    lastName = '';
    selectedSchoolId = -99;
    selectedRoleId = 0;
    activeToday = false;
    schools: School[] = [];
    selectedStaffIds: number[] = [];
    selectedStaff: Staff[] = [];
    isSpedMaintainTeamPage = false;
    startOverClicked: boolean;

    @ViewChild('inputLastName', { static: false }) inputLastName: ElementRef;

    // @ViewChild(MatPaginator) paginator: MatPaginator;
    private _paginator: MatPaginator;
    @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
        this._paginator = value;
        this.dataSource.paginator = value;
    }
    _sort: MatSort;
    @ViewChild(MatSort) set sort(value: MatSort) {
        this._sort = value;
        this.dataSource.sort = value;
    }
    get sort(): MatSort {
        return this._sort;
    }
    isV10: boolean;
    todayDate: string;
    permissionGroups: PermissionGroupDescription[] = [];
    redirectUrl = '';
    userName = '';

    selectedPermissionGroupId = 0;
    Roles = [{ RoleName: '', Id: 0 },
    { RoleName: 'Teacher', Id: 1 },
    { RoleName: 'Substitute Teacher', Id: 2 },
    { RoleName: 'Advisor', Id: 3 },
    { RoleName: 'Counselor', Id: 4 },
    { RoleName: 'Nurse', Id: 5 },
    { RoleName: 'Disciplinarian', Id: 6 },
    { RoleName: 'Site Administrator', Id: 7 },
    { RoleName: 'District Administrator', Id: 8 },
    { RoleName: 'Principal', Id: 9 },
    { RoleName: 'Other Staff', Id: 10 },
    { RoleName: 'Special Ed Teacher', Id: 11 },
    { RoleName: 'Special Ed Service Provider', Id: 12 },
    { RoleName: 'Special Ed Case Manager', Id: 13 },
    { RoleName: 'Special Ed Supervisor', Id: 14 }
    ];
    teacher = '%';
    substitute = '%';
    advisor = '%';
    counselor = '%';
    nurse = '%';
    disciplinarian = '%';
    administrator = '%';
    superintendent = '%';
    principal = '%';
    other = '%';
    specialEdTeacher = '%';
    specialEdServiceProvider = '%';
    specialEdCaseManager = '%';
    staffStatus = 'All';
    showAllSchool = false;
    showAllPermissionGroups = false;

    isBusy = false;
    // Class Functions
    constructor(
        private loginService: LoginService,
        private staffSearchService: StaffSearchService,
        private yearService: YearService,
        private dialogRef: MatDialogRef<StaffSearchComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private dataQueryService: DataQueryService,
        private permissionGroupService: PermissionsGroupsService,
        private staffService: StaffService,
        private router: Router
    ) { }

    get currentQuery(): DataQuery {
        return this._currentQuery;
    }

    set currentQuery(value: DataQuery) {
        this.dataQueryService.currentQuery = value;
        if (!value) {
            this.staffSearchService.unsavedQueryApplied = false;
        }
    }

    get information(): DataQueryInformation {
        return this._information;
    }

    // Event Functions
    ngOnInit() {
        this.todayDate = new Date().toLocaleDateString();
        this.getPermissionGroup();

        // Setting the initial data
        this.isV10 = this.loginService.LoginSettings.V10;
        this.staffStatus = 'All';
        if (this.data.iseForm || this.isV10 == false) {
            this.staffStatus = 'Active';
        }


        if (this.isV10 == false) {
            this.getSearchCriteria();
            this.staffStatus = this.staffSearchService.staffSearchCriteria.Status != undefined ? this.staffSearchService.staffSearchCriteria.Status : 'Active';
        }
        if (!this.isV10 && this.data.pageName != null) {
            if (this.data.pageName == 'SchoolSections') {
                this.Roles = [];
                this.Roles = [
                    { RoleName: 'Teacher', Id: 1 }
                ];
                this.selectedRoleId = 1;
            }
            if (this.data.pageName == 'behaviorReferral') {
                this.Roles = [];
                this.Roles = [
                    { RoleName: 'Disciplinarian', Id: 6 }
                ];
                this.selectedRoleId = 6;
            }
            if (this.data.pageName == 'manageTeam') {
                this.isSpedMaintainTeamPage = true;
                this.Roles = [];
                this.Roles = [{ RoleName: '', Id: 0 },
                { RoleName: 'Special Ed Teacher', Id: 11 },
                { RoleName: 'Special Ed Service Provider', Id: 12 },
                { RoleName: 'Special Ed Case Manager', Id: 13 },
                { RoleName: 'Special Ed Supervisor', Id: 14 }
                ];
            }
        }
        if (this.data.selectedStaff) {
            this.selectedStaff = cloneDeep(this.data.selectedStaff);
            this.selectedStaffIds = this.data.selectedStaff.map(staff => staff.StaffId);
        }
        if (this.data.searchAndSelect != null) {
            this.searchAndSelect = this.data.searchAndSelect;
        }
        if (this.data.redirectUrl != null) {
            this.redirectUrl = this.data.redirectUrl;
        }

        // Setting up data query
        this.dataQueryService.getInformation().subscribe();
        this.dataQueryService.currentQuery = new DataQuery();
        this.dataQueryService.isStaffSearch = true;

        // Obtaining the schools that should be available in the dropdown
        if (this.data.schools) {
            this.schools = this.data.schools;
            this.setSelectedSchool();
        } else if (this.data.schoolIds) {
            this.subscriptions.push(this.yearService.getSchoolsBySchoolIds(this.data.schoolIds).subscribe(schools => {
                this.schools = sortBy(schools, ['SchoolName']);
                this.setSelectedSchool();
            }));
        } else {
            this.schools = this.yearService.schools;
            this.setSelectedSchool();
        }
        this.staffSearchService.unsavedQueryApplied = false;

        // Obtaining data
        this.subscriptions.push(

            // Syncing properties
            this.dataQueryService.observableCurrentQueryStream$.subscribe(query => {
                this._currentQuery = query;
                this._currentQuery.StudentSearch = false;
                this._currentQuery.CourseSearch = false;
                this._currentQuery.StaffSearch = true;
                this.dataQueryService.checkDefaultFilterFields(this._currentQuery.filterFields);
            }),
            this.dataQueryService.observableInformationStream$.subscribe(information => {
                this._information = information;
                if (this.currentQuery && !this.information.recentStaffFilters.find(filterQuery => filterQuery == this.currentQuery)) {
                    const matchingQuery = this.information.recentStaffFilters.find(filterQuery => filterQuery.ID == this.currentQuery.ID);
                    if (matchingQuery) {
                        this.currentQuery = matchingQuery;
                    }
                }
                if (!this.dataQueryService.obtainedRecentStaffQueries && !this.dataQueryService.isInformationCached()) {
                    this.subscriptions.push(
                        this.dataQueryService.getRecentQueries().subscribe(recentFilters => {
                            this.information.recentStaffFilters = recentFilters;
                            this.dataQueryService.obtainedRecentStaffQueries = true;
                        })
                    );
                }
            }),

            // Obtaining data
            this.dataQueryService.getPermissions().subscribe()
        );

        // Setting up the table
        if (this.isV10) {
            this.columnsToDisplay = ['select', 'EmployeeNumber', 'FirstName', 'MiddleName', 'LastName', 'StaffRole', 'SchoolName', 'UseInScheduling'];
        }
        else {
            this.columnsToDisplay = [];
            this.columnsToDisplay = ['select', 'StaffName', 'EmployeeNumber', 'UserName', 'SchoolName', 'PermissionGroup', 'StaffRole', 'InActiveDate'];
        }
        if (!this.searchAndSelect) {
            this.columnsToDisplay.splice(0, 1);
        }
        this.defaultColumns = this.columnsToDisplay.filter(column => column != 'select');
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string | number => {
            // created defaultSortingAccessor so components can override sortingAccessor and still fall back on the default if needed
            const staff = data as Staff;
            switch (sortHeaderId) {
                case 'UseInScheduling':
                    return staff.UseInScheduling ? 'Y' : '';
                default:
                    return this.dataSource.defaultSortingAccessor(data, sortHeaderId);
            }
        };

        if (this.staffService.refreshStaffSearchGrid) {
            // Called to refresh the grid, when BACK button is hit on School Selection window.
            this.searchClick();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => this.inputLastName.nativeElement.focus());
    }

    ngOnDestroy() { }

    searchClick() {
        this.startOverClicked = false;
        if (this.isSpedMaintainTeamPage == false) {
            this.saveSearchCriteria();
        }
        if (this.currentQuery.filterFields.length > 0) {
            this.dataQueryService.getResults(
                false,
                (results: DataQueryResult) => {
                    this.processStaffFilterResults(results);
                },
                () => {
                },
                true
            );
        } else {
            this.getStaff();
        }
    }

    cancelClick() {
        this.dialogRef.close();
    }

    staffSelected(staff: Staff) {
        staff.Selected = !staff.Selected;
        if (!staff.Selected) {
            this.allSelected = false;
            const i = this.selectedStaff.findIndex(o => o.StaffId == staff.StaffId);
            if (i >= 0) {
                if (this.dataSource.data.filter(x => x.StaffId == staff.StaffId && x.Selected == true).length == 0) {
                    this.selectedStaff.splice(i, 1);
                }
            }
            const idIndex = this.selectedStaffIds.findIndex(staffId => staffId == staff.StaffId);
            if (idIndex >= 0) {
                this.selectedStaffIds.splice(idIndex, 1);
            }
        }
        else {
            if (this.selectedStaff.find(o => o.StaffId == staff.StaffId) == null) {
                this.selectedStaff.push(staff);
            }
            this.selectedStaffIds.push(staff.StaffId);
        }
        event.preventDefault();
    }

    showSelectedStaff() {
        // PRE: the Selected Staff in the footer is clicked
        // POST: opens the dialog to show the selected staff
        this.dialog.open(StaffListDialogComponent, {
            disableClose: true,
            maxWidth: '90%',
            minWidth: '90%',
            data: {
                staff: this.selectedStaff
            }
        });
    }

    checkAll() {
        this.allSelected = !this.allSelected;
        this.dataSource.filteredData.forEach(staff => {
            if (staff.Selected != this.allSelected) {
                this.staffSelected(staff);
            }
        });
    }

    rowSelected(staff: Staff) {
        if (!this.searchAndSelect) {
            this.staffService.selectedStaff = staff;
            this.staffService.updateStaff(this.staff, staff);
            this.route(staff);
        }
    }

    route(staff: Staff) {
        if (this.redirectUrl != '') {
            this.router.navigateByUrl(this.redirectUrl);
        }
        this.dialogRef.close(staff);
    }

    selectClick() {
        this.selectedStaff.forEach(staff => {
            const staffRows = this.dataSource.data.filter(o => o.StaffId == staff.StaffId);
            if (staffRows && staffRows.length > 0) {
                staff.SelectedSchools = [];
                staffRows.forEach(school => {
                    if (school.Selected) {
                        staff.SelectedSchools.push(school.SchoolName);
                    }
                });
            }
        });

        this.dialogRef.close(this.selectedStaff);
    }

    clearFilter() {
        this.dataSource.removeAllFilters();
    }

    staffFiltersClick() {
        // PRE: the Staff Filter button on the footer is clicked
        // POST: opens the Advanced Staff Search dialog
        const dialogBox = this.dialog.open(AdvancedStaffSearchComponent, {
            disableClose: true
        });
        dialogBox.afterClosed().pipe(take(1)).subscribe((results: DataQueryResult) => {
            if (results) {

                // Setting up the grid based on the results
                this.processStaffFilterResults(results);

                // Toggling whether this is an unsaved query
                this.staffSearchService.unsavedQueryApplied = !this.currentQuery.QueryName;
            }
        });
    }

    // Local Methods
    setSelectedSchool() {
        const selectedSchool = this.schools.find(o => o.Id == this.yearService.defaultYear.SchoolID);
        if (selectedSchool) {
            this.selectedSchoolId = (this.isV10 == false && this.selectedSchoolId != -99) ? this.selectedSchoolId : selectedSchool.Id;
        }
        else {
            if (this.schools.length > 0) {
                this.selectedSchoolId = this.schools[0].Id;
            }
        }
    }

    getStaff() {
        const schoolIds = this.schools.map(o => o.Id);
        if (!this.isV10) {
            this.teacher = '%';
            this.substitute = '%';
            this.advisor = '%';
            this.counselor = '%';
            this.nurse = '%';
            this.disciplinarian = '%';
            this.administrator = '%';
            this.superintendent = '%';
            this.principal = '%';
            this.other = '%';
            this.specialEdTeacher = '%';
            this.specialEdServiceProvider = '%';
            this.specialEdCaseManager = '%';
            switch (this.selectedRoleId) {
                case 1:
                    this.teacher = '1';
                    break;
                case 2:
                    this.substitute = '1';
                    break;
                case 3:
                    this.advisor = '1';
                    break;
                case 4:
                    this.counselor = '1';
                    break;
                case 5:
                    this.nurse = '1';
                    break;
                case 6:
                    this.disciplinarian = '1';
                    break;
                case 7:
                    this.administrator = '1';
                    break;
                case 8:
                    this.administrator = '1';
                    break;
                case 9:
                    this.principal = '1';
                    break;
                case 10:
                    this.other = '1';
                    break;
                case 11:
                    this.specialEdTeacher = '1';
                    break;
                case 12:
                    this.specialEdServiceProvider = '1';
                    break;
                case 13 || 14:
                    this.specialEdCaseManager = '13';
                    break;
                default:
                    this.selectedRoleId = this.selectedRoleId == 14 ? this.selectedRoleId : 0;
                    break;
            }
        }
        this.isBusy = true;
        this.subscriptions.push(this.staffSearchService.getStaffSearch(
            this.selectedSchoolId,
            this.yearService.defaultYear.Id,
            this.activeToday,
            this.employeeNumber,
            this.firstName,
            this.lastName,
            schoolIds,
            this.teacher,
            this.substitute,
            this.advisor,
            this.counselor,
            this.nurse,
            this.disciplinarian,
            this.administrator,
            this.superintendent,
            this.principal, this.other,
            this.specialEdTeacher,
            this.specialEdServiceProvider,
            this.specialEdCaseManager,
            false,
            this.staffStatus,
            this.selectedPermissionGroupId,
            this.userName,
            this.showAllSchool,
            this.showAllPermissionGroups
        ).subscribe(staff => {
            this.allSelected = false;
            this.staff = staff;
            this.staff.forEach(staffMember => {
                const staffSelected = !!this.selectedStaffIds.find(staffId => staffId == staffMember.StaffId);
                const selectedStaff = this.selectedStaff.find(potentialSelection => potentialSelection.StaffId == staffMember.StaffId);
                if (staffSelected) {
                    if (selectedStaff) {
                        Object.assign(selectedStaff, staffMember);
                    } else {
                        this.selectedStaff.push(selectedStaff);
                    }
                }
            });

            this.selectedStaff.forEach(s => {
                const gridStaff = this.staff.find(o => o.StaffId == s.StaffId);
                if (gridStaff) {
                    Object.assign(s, gridStaff);
                    gridStaff.Selected = true;
                }
            });
            if (!this.isV10 && this.staffStatus != 'All') {
                this.staff = [];
                this.staff = staff.filter(s => s.StaffStatus == this.staffStatus);
            }
            if (this.isSpedMaintainTeamPage == true) {
                this.staff = this.staff.filter(x => x.StaffRole.includes('SPED'));
            }

            if (this.showAllSchool) {
                this.selectedStaff.forEach(st => {
                    this.staff.filter(o => o.StaffId == st.StaffId).forEach(school => {
                        if (st.SelectedSchools && st.SelectedSchools.includes(school.SchoolName)) {
                            school.Selected = true;
                        } else {
                            school.Selected = false;
                        }
                    });
                });

                this.clearSelectedStaff();
            }

            this.dataSource.data = this.staff;
            this.isBusy = false;
        }));
    }

    isDataFiltered(): boolean {
        return this.dataSource.isFiltered();
    }

    checkAdvancedFilter(): boolean {
        // POST: returns true if there is an advanced filter
        return this.staffSearchService.unsavedQueryApplied || this.currentQuery.ID != -1;
    }

    processStaffFilterResults(results: DataQueryResult) {
        // PRE: a set of results from data query
        // POST: applies those results to the grid

        // Constructing the courses based on the results
        const staff: Staff[] = [];
        if (this.isV10) {
            results.Data.forEach(datum => {
                const staffMember = new Staff();
                for (let i = 0; i < datum.length; i++) {
                    switch (results.Columns[i].FieldName) {
                        case 'Staff_ID':
                            staffMember.StaffId = Number.parseInt(datum[i], 10);
                            break;
                        case 'Employee_Number':
                            staffMember.EmployeeNumber = datum[i];
                            break;
                        case 'Employee_First_Name':
                            staffMember.FirstName = datum[i];
                            break;
                        case 'Employee_Middle_Name':
                            staffMember.MiddleName = datum[i];
                            break;
                        case 'Employee_Last_Name':
                            staffMember.LastName = datum[i];
                            break;
                        case 'School_Name':
                            staffMember.SchoolName = datum[i];
                            break;
                        case 'JobDesc':
                            staffMember.StaffRole = datum[i];
                            break;
                        case 'UseForScheduling':
                            staffMember.UseInScheduling = datum[i].toLowerCase() == 'true';
                            break;
                        default:
                            break;
                    }
                }
                staff.push(staffMember);
            });
        } else {
            results.Data.forEach(datum => {
                const staffMember = new Staff();
                for (let i = 0; i < datum.length; i++) {
                    switch (results.Columns[i].FieldName) {
                        case 'ID':
                            staffMember.EmployeeNumber = datum[i];
                            break;
                        case 'lngFacultyStaffId':
                            staffMember.StaffId = Number.parseInt(datum[i], 10);
                            break;
                        case 'Name - First':
                            staffMember.FirstName = datum[i];
                            break;
                        case 'Name - Middle':
                            staffMember.MiddleName = datum[i];
                            break;
                        case 'Name - Last':
                            staffMember.LastName = datum[i];
                            break;
                        case 'Name':
                            staffMember.StaffName = datum[i];
                            break;
                        case 'Pri Assign Site Name':
                            staffMember.SchoolName = datum[i];
                            break;
                        case 'Roles':
                            staffMember.StaffRole = datum[i];
                            break;
                        case 'User Name':
                            staffMember.UserName = datum[i];
                            break;
                        case 'Perm Group':
                            staffMember.PermissionGroup = datum[i];
                            break;
                        case 'State ID':
                            staffMember.StateId = datum[i];
                            break;
                        default:
                            break;
                    }
                }
                staff.push(staffMember);
            });
        }

        // Applying the data to the grid
        this.dataSource.data = staff;
        this.isBusy = false;
    }

    keyDownFunction(event) {
        if (event.keyCode == 13) {
            this.searchClick();
        }
    }

    getPermissionGroup() {
        this.permissionGroupService.getPermissionGroupDescription().subscribe(result => {
            this.permissionGroups = result.filter(o => o.Active == true);
        });
    }

    startOverClick() {
        this.startOverClicked = true;
        this.restoreDefaultsClick();
        this.staffSearchService.staffSearchCriteria = new StaffSearchCriteria();
        this.employeeNumber = '';
        this.lastName = '';
        this.firstName = '';
        const selectedSchool = this.schools.find(o => o.Id == this.yearService.defaultYear.SchoolID);
        if (selectedSchool) {
            this.selectedSchoolId = selectedSchool.Id;
        }
        else {
            if (this.schools.length > 0) {
                this.selectedSchoolId = this.schools[0].Id;
            }
        }
        this.selectedPermissionGroupId = 0;
        this.selectedRoleId = 0;
        this.userName = '';
        this.staffStatus = 'Active';
        this.showAllSchool = false;
        this.showAllPermissionGroups = false;
        this.selectedStaff = [];
        this.inputLastName.nativeElement.focus();
        this.dataSource.data = [];
    }

    columnActive(column: string) {
        // PRE: the column name from the table definition
        // POST: returns whether or not that column is in the table
        return this.columnsToDisplay.includes(column);
    }

    getColumnHeader(column: string) {
        // PRE: the column name from the table definition
        // POST: returns the header from the table
        switch (column) {

            case 'EmployeeNumber':
                return this.isV10 ? 'Employee Number' : 'Employee #';

            case 'SchoolName':
                return this.isV10 ? 'Primary School' : 'School';

            case 'StaffRole':
                return this.isV10 ? 'Primary Job' : 'Role';

            default:
                return column;
        }
    }

    addColumn(column: string) {
        // PRE: one of the checkboxes from the column list is checked
        // POST: toggles whether that column is in the table
        if (!this.columnActive(column)) {
            this.columnsToDisplay.push(column);
        } else {
            this.columnsToDisplay.splice(this.columnsToDisplay.indexOf(column), 1);
        }
        this.columnsToDisplay.sort((a, b) => {
            const indexOfA = this.defaultColumns.indexOf(a);
            const indexOfB = this.defaultColumns.indexOf(b);
            return indexOfA - indexOfB;
        });
    }

    restoreDefaultsClick() {
        // PRE: The Restore Defaults button on the column list is checked
        // POST: sets the columns to their initial set
        this.columnsToDisplay = cloneDeep(this.defaultColumns);
        if (this.searchAndSelect) {
            this.columnsToDisplay.unshift('select');
        }
    }

    saveSearchCriteria() {
        this.staffSearchService.staffSearchCriteria.FirstName = this.firstName;
        this.staffSearchService.staffSearchCriteria.LastName = this.lastName;
        this.staffSearchService.staffSearchCriteria.UserName = this.userName;
        this.staffSearchService.staffSearchCriteria.EmployeeNumber = this.employeeNumber;
        this.staffSearchService.staffSearchCriteria.SchoolId = this.selectedSchoolId;
        this.staffSearchService.staffSearchCriteria.Status = this.staffStatus;
        this.staffSearchService.staffSearchCriteria.ShowAllSchools = this.showAllSchool;
    }

    getSearchCriteria() {
        this.firstName = this.staffSearchService.staffSearchCriteria.FirstName != undefined ? this.staffSearchService.staffSearchCriteria.FirstName : this.firstName;
        this.lastName = this.staffSearchService.staffSearchCriteria.LastName != undefined ? this.staffSearchService.staffSearchCriteria.LastName : this.lastName;
        this.userName = this.staffSearchService.staffSearchCriteria.UserName != undefined ? this.staffSearchService.staffSearchCriteria.UserName : this.userName;
        this.employeeNumber = this.staffSearchService.staffSearchCriteria.EmployeeNumber != undefined ? this.staffSearchService.staffSearchCriteria.EmployeeNumber : this.employeeNumber;
        this.selectedSchoolId = this.staffSearchService.staffSearchCriteria.SchoolId != undefined ? this.staffSearchService.staffSearchCriteria.SchoolId : this.selectedSchoolId;
        this.staffStatus = this.staffSearchService.staffSearchCriteria.Status != undefined ? this.staffSearchService.staffSearchCriteria.Status : this.staffStatus;
        this.showAllSchool = this.staffSearchService.staffSearchCriteria.ShowAllSchools != undefined ? this.staffSearchService.staffSearchCriteria.ShowAllSchools : this.showAllSchool;
    }

    showAllSchoolClick() {
        this.staffSearchService.staffSearchCriteria.ShowAllSchools = this.showAllSchool;
        this.getStaff();
    }

    showAllPermissionsGroupsClick() {
        this.staffSearchService.staffSearchCriteria.ShowAllPermissionsGroups = this.showAllPermissionGroups;
        this.getStaff();
    }

    checkPriorDate(date: string): boolean {
        if (date != '') {
            if (Date.parse(date) <= Date.parse(this.todayDate)) {
                return true;
            }
        }

        return false;
    }

    clearSelectedStaff() {
        // this.selectedStaff.forEach((x, index) => {
        //     if (x.HasSchoolSpecificPermissions) {
        //         const schools = this.staff.filter(o => o.StaffId == x.StaffId);
        //         if (schools.filter(s => s.Selected == true).length == 0) {
        //             this.selectedStaff.splice(index, 1);
        //         }
        //     }
        // });
    }
}
